module.exports = {
  reducerActions: {
    login: "LOGIN",
    signUp: "SIGN_UP",
    forgotPassword: "FORGOT_PASSWORD",
    changePassword: "CHANGE_PASSWORD",
    verifyEmail: "VERIFY_EMAIL",
    mailSent: "MAIL_SENT",
    registered: "REGISTERED",
    userDetails: "USER_DETAILS",
    allJobs: "ALL_JOBS",
    fetchingJobs: "FETCHING_JOBS",
    jobDetail: "JOB_DETAIL",
    skills: "ALL_SKILLS",
    progress: "JOB_PROGRESS",
    notifications: "ALL_NOTIFICATIONS",
    imageUrl: "IMAGE_URL",
  },
  clientActions: {
    profile: "T24_PROFILE",
    uploadFile: "FILE_UPLOAD",
    jobCreated: "JOB_CREATED",
    applications: "APPLICATIONS",
    searchJobs: "JOBS_SEARCHED",
    dashboard: "DASHBOARD",
    userDetails: "USER_DETAILS",
    updateT24: "T24_PROFILES",
    profileCompletion: "PROFILE_COMPLETION",
  },
  consultantActions: {
    getSkills: "FETCH_SKILLS",
    addSkills: "ADD_SKILLS",
    hasNoSkills: "HAS_NO_SKILLS",
    userSkills: "USER_SKILLS",
    jobApplied: "JOB_APPLIED",
    sliceSkills: "SLICED_SKILLS",
    searchJobs: "JOBS_SEARCHED",
    applications: "MY_APPLICATIONS",
    application: "APPLICATION_DETAIL",
    allOffers: "OFFERS",
    currentJobs: "CURRENT_JOBS",
    allComments: "ALL_COMMENTS",
    dashboard: "DASHBOARD",
    userDetails: "USER_DETAILS",
    profileCompletion: "PROFILE_COMPLETION",
  },
  adminActions: {
    fetchAllSkills: "ALL_SKILLS",
  },
  status: {
    success: 200,
    created: 201,
    unAuthorative: 203,
    invalidFields: 422,
    notFound: 404,
    unAuthorized: 401,
    conflict: 409,
    server: 500,
  },
  roles: {
    client: "CLIENT",
    consultant: "CONSULTANT",
    admin: "ADMIN",
  },
  errors: {
    invalidMail: "INVALID_MAIL",
    passwordIncorrect: "INCORRECT_PASSWORD",
    mailAlreadyExists: "EMAIL_ALREADY_EXISTS",
  },
  offerStatus: {
    expired: "expired",
    reject: "reject",
    accepted: "accepted",
  },
  commentTypes: {
    standard: "STANDARD",
    clarification: "CLARIFICATION",
    comment: "COMMENT",
  },
  clarificationStatus: {
    open: "Open",
    close: "Closed",
  },
};
